<template>
  <div class="main-bar">
    <div class="grid">
      <img
        class="bg-img"
        :src="require('@/assets/hitech/mai-bg.png')"
        alt="background"
      />
      <div class="grid__left">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list"
          :key="item.id"
          class="card"
        >
          <transition name="fade-up">
            <div class="card-top" v-show="index == activeIndex">
              <span class="category">{{ item.sub_category.name }}</span>
              <h3 class="title limited-text">{{ item.title }}</h3>
            </div>
          </transition>
          <transition name="fade-down">
            <div class="card-bottom" v-show="index == activeIndex">
              <p
                v-html="changeFirstLetter(item.brief)"
                class="brief limited-text"
              ></p>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }}</span>
              </div>
            </div>
          </transition>
        </router-link>
      </div>
      <div class="grid__right">
        <div class="container">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url }
              })
            "
            v-for="(item, index) in slides"
            :key="item.id"
            class="container__img"
            :class="`img${index}`"
          >
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </router-link>
        </div>
        <button
          @click="incrementActiveIndex(), handleSlide()"
          class="change-slide"
        >
          <i class="fal fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  // :style="{
  //   transform: `translateX(calc(-${activeIndex * 100}%))`
  // }"
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const slides = ref([]);
    slides.value = JSON.parse(JSON.stringify(props.list));

    const activeIndex = ref(1);

    const incrementActiveIndex = (to = 1) => {
      activeIndex.value =
        activeIndex.value + to < 0
          ? (activeIndex.value = props.list.length - 1)
          : activeIndex.value + to > props.list.length - 1
          ? 0
          : activeIndex.value + to;
    };

    const handleSlide = (dir = 1) => {
      slides.value.push(...slides.value.splice(0, dir));
    };

    return {
      activeIndex,
      slides,
      handleSlide,
      incrementActiveIndex,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-bar {
  width: 100%;
  // height: calc(80vh - var(--header-main-height));
  overflow: hidden;
  color: #ffffff;
  background-size: cover;

  background-image: linear-gradient(
    180deg,
    rgba(18, 18, 18, 0.9) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}
.grid {
  width: 90%;
  margin: 0 auto;
  display: grid;
  padding-top: calc(max(110px, 9vw));
  grid-template-columns: repeat(12, 1fr);
  align-items: center;
  gap: 1.5vw;
  height: 100%;
  position: relative;
  .bg-img {
    background: transparent;
    z-index: -1;
    position: absolute;
    top: 65%;
    left: 54%;
    transform: translate(-50%, -50%);
  }
  &__left {
    grid-column: 1 / span 5;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: 100%;
    position: relative;
  }
  &__right {
    height: 100%;
    grid-column: 8 / span 5;
    position: relative;
    .change-slide {
      color: #8e1541;
      background: rgba(18, 18, 18, 0.2);
      cursor: pointer;
      position: absolute;
      top: 50%;
      right: -13.7%;
      transform: translateY(-50%);
      font-size: 3rem;
      height: 100%;
      width: 5vw;
    }
  }
  .category {
    font-family: Roboto;
    color: #be1653;
    font-weight: 500;
    font-size: 2em;
  }
  .title {
    font-family: 'Noto Serif', serif;
    font-weight: 600;
    font-size: 2.8em;
    line-height: 1.3;
    margin-bottom: 35px;
    --snup: 4;
  }
  .brief {
    font-family: Roboto;
    font-size: 1.5em;
    line-height: 140%;
    --snup: 6;
  }
  .data-news {
    font-family: Roboto;
    font-size: 1em;
    line-height: 1.1;
    text-align: right;
    /* identical to box height */
    color: rgba(205, 205, 205, 0.5);
  }
  .container {
    display: flex;
    flex-wrap: nowrap;

    height: 100%;
    width: 200%;
    overflow-x: hidden;

    &__img {
      flex: 0 0 50%;
      // height: 100%;
      width: 100%;
      margin: auto;
      padding-left: 2.5vw;
      transition: all 0.5s;
      transform: translateX(-2.5vw);
      .img {
        border-radius: 0px;
        height: 100%;
        padding-bottom: 75%;
        :deep() img {
          border-radius: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 1700px) {
  .grid {
    margin-top: 2.5rem;
    margin-bottom: 5rem;
    .title {
      font-family: 'Noto Serif', serif;
      font-size: 2.2em;
      line-height: 1.3;
      margin-bottom: 0;
      --snup: 3;
    }
    .brief {
      margin-top: 2rem;
      font-family: Roboto;
      font-size: 1.2em;
      line-height: 140%;
      --snup: 4;
    }
  }
}
@media screen and (max-width: 992px) {
  .main-bar {
    margin-top: 6rem;
    .bg-img {
      background: transparent;
      z-index: -1;
      position: absolute;
      top: 50%;
      left: 65%;
      width: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .grid {
    margin: 0 auto;
    padding: 2rem 0;
    grid-template-columns: repeat(6, 1fr);
    gap: 28px;
    &__left {
      grid-column: 1 / span 3;
    }
    &__right {
      height: auto;
      grid-column: 4 / span 3;
    }
    .category {
      font-size: 1em;
    }
    .title {
      font-size: 1.5em;
    }
    .brief {
      font-size: 1.125em;
    }

    .data-news {
      font-size: 1em;
      margin-top: 1rem;
    }
    .container {
      width: 100%;
      height: 80%;
      align-items: center;
      &__img {
        padding: 0;
        height: 253px;
        flex: 0 0 calc(100% - 5vw);
        transform: translateX(0);
        .img {
          padding-bottom: 0;
        }
      }
    }
    .change-slide {
      right: 0;
    }
    .img1 {
      margin-right: 5vw;
    }
    .img2 {
      margin-right: 5vw;
    }
  }
}

.img0 {
  width: 0;
  height: 100%;
  align-self: stretch;
  flex: 0 0 0% !important;
  transform: translateX(-150%) !important;
}

.card-top {
  position: absolute;
  bottom: 49%;
}
.card-bottom {
  position: absolute;
  top: 49%;
  // transform: translateY(60%);
}

.fade-up-enter-active,
.fade-down-enter-active,
.fade-up-leave-active,
.fade-down-leave-active {
  transition: all 0.5s;
}

.fade-up-enter-from {
  opacity: 0;
  transform: translateY(-100%);
}
.fade-down-enter-from {
  opacity: 0;
  transform: translateY(100%);
}

.fade-up-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
.fade-down-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.toLeft-enter-active,
.toLeft-enter-active {
  transition: all 0.5s;
}
.toLeft-enter-from {
  transform: translateX(-100%);
}
.toLeft-leave-to {
  transform: translateX(100%);
}
</style>
